<template>
  <div class="con-tab-ejemplo">
    <vs-row vs-w="12" style="padding: 2em 0em">
      <vs-col vs-lg="3" style="width: 100%">
        <div class="centerx">
          <vs-upload
            action="http://192.168.45.239:8096/asset/upload-pic-asset"
            @on-success="successUpload"
            @on-error="errorUpload"
            data="{'assetID':18}"
            fileName="file"
            limit="1"
            automatic
          />
        </div>
        <!-- <div
            style="
              border-radius: 50%;
              height: 200px;
              width: 200px;
              overflow: hidden;
              display: inline-block;
              vertical-align: middle;
            "
          >
            <img
              style="width: 100%"
              src="https://images.pexels.com/photos/4411430/pexels-photo-4411430.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            />
          </div> -->
      </vs-col>

      <vs-col vs-lg="9">
        <vs-row vs-w="12" style="align-items: center">
          <vs-col vs-lg="2">
            <b> Name : </b>
          </vs-col>
          <vs-col vs-lg="4">
            <vs-input v-model="assetdata.name" />
          </vs-col>
          <vs-col vs-lg="6">
            <vs-button
              radius
              class="mb-2 mr-2"
              color="primary"
              type="line"
              icon="cloud_download"
              icon-color="red"
              style="float: right"
            />
            <vs-button
              radius
              class="mb-2 mr-2"
              color="#FF8800"
              type="line"
              icon="print"
              style="float: right"
            />
            <BtnQrcode />
            <vs-tooltip text="Manage attribute asset">
              <vs-button
                radius
                class="mb-2 mr-2"
                color="#555555"
                type="line"
                icon="settings"
                style="float: right"
              />
            </vs-tooltip>
          </vs-col>
        </vs-row>

        <vs-divider />

        <vs-row vs-w="12">
          <vs-col vs-lg="6">
            Warranty :
            <!--  <b-button class="ml-3" @click="startLoading()">Reload</b-button>
            <b-button class="ml-3" @click="stopLoading()">stop</b-button> -->
          </vs-col>
          <vs-col vs-lg="6">
            Depreciation :
            <!--   <b-button class="ml-3" @click="nextLoading()">next</b-button> -->
          </vs-col>
          <vs-col vs-lg="6"> Service life : </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-divider />
    <div>
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <b-card>
            <b-skeleton width="85%"></b-skeleton>
            <b-skeleton width="55%"></b-skeleton>
            <b-skeleton width="70%"></b-skeleton>
          </b-card>
        </template>

        <b-card :data="assetAttr" style="border: none">
          <b-container id="infoAttrAsset" class="bv-example-row">
            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_Texts"
              class="rowAttrAsset"
              style="align-items: center"
            >
              <b-col cols="1">fix</b-col>
              <b-col cols="2">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  keyboard_alt
                </span>
                {{
                  assetAttr.Assets_Field_Texts[indextr].asset_FieldText_CusName
                }}
              </b-col>
              <b-col cols="8">
                <vs-input
                  class="inputx"
                  :id="'txt' + assetAttr.Assets_Field_Texts[indextr].id"
                  v-model="
                    assetAttr.Assets_Field_Texts[indextr].asset_FieldText_Data
                  "
                  @change="
                    updateAttrAssetText(assetAttr.Assets_Field_Texts[indextr])
                  "
                />
              </b-col>
              <b-col cols="1">
                <confirmDel
                  :assetID="assetID"
                  :id="assetAttr.Assets_Field_Texts[indextr].id"
                  :attrName="
                    assetAttr.Assets_Field_Texts[indextr]
                      .asset_FieldText_CusName
                  "
                  type="Text"
                  size="sm"
                  class="confirmDel"
                />
              </b-col>
            </b-row>

            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_Numbers"
              class="rowAttrAsset"
              style="align-items: center"
            >
              <b-col cols="1">fix</b-col>
              <b-col cols="2">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  tag
                </span>
                {{
                  assetAttr.Assets_Field_Numbers[indextr].asset_FieldNum_CusName
                }}
              </b-col>
              <b-col cols="8">
                <vs-input
                  class="inputx"
                  :id="'num' + assetAttr.Assets_Field_Numbers[indextr].id"
                  v-model="
                    assetAttr.Assets_Field_Numbers[indextr].asset_FieldNum_Data
                  "
                  @change="
                    updateAttrAssetNum(assetAttr.Assets_Field_Numbers[indextr])
                  "
                />
              </b-col>
              <b-col cols="1">
                <confirmDel
                  :assetID="assetID"
                  :id="assetAttr.Assets_Field_Numbers[indextr].id"
                  :attrName="
                    assetAttr.Assets_Field_Numbers[indextr]
                      .asset_FieldNum_CusName
                  "
                  type="Number"
                  size="sm"
                  class="confirmDel"
                />
              </b-col>
            </b-row>

            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_CURs"
              class="rowAttrAsset"
              style="align-items: center"
            >
              <b-col cols="1">fix</b-col>
              <b-col cols="2">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  paid
                </span>
                {{
                  assetAttr.Assets_Field_CURs[indextr].asset_FieldCUR_CusName
                }}
              </b-col>
              <b-col cols="8">
                <vs-chip> ฿ </vs-chip>
                <vs-input
                  :id="'cur' + assetAttr.Assets_Field_CURs[indextr].id"
                  v-model="
                    assetAttr.Assets_Field_CURs[indextr].asset_FieldCUR_Data
                  "
                  class="inputx"
                  @change="
                    updateAttrAssetCUR(assetAttr.Assets_Field_CURs[indextr])
                  "
                />
              </b-col>
              <b-col cols="1">
                <confirmDel
                  :id="assetAttr.Assets_Field_CURs[indextr].id"
                  :attrName="
                    assetAttr.Assets_Field_CURs[indextr].asset_FieldCUR_CusName
                  "
                  type="Currency"
                  size="sm"
                  class="confirmDel"
                />
              </b-col>
            </b-row>

            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_Dates"
              class="rowAttrAsset"
              style="align-items: center"
            >
              <b-col cols="1">fix</b-col>
              <b-col cols="2">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  calendar_today
                </span>
                {{
                  assetAttr.Assets_Field_Dates[indextr].asset_FieldDate_CusName
                }}
              </b-col>
              <b-col cols="8">
                <b-col cols="4">
                  <b-form-datepicker
                    :id="'date' + assetAttr.Assets_Field_Dates[indextr].id"
                    :value="
                      assetAttr.Assets_Field_Dates[indextr].asset_FieldDate_Data
                    "
                    v-model="
                      assetAttr.Assets_Field_Dates[indextr].asset_FieldDate_Data
                    "
                    @input="
                      updateAttrAssetDate(assetAttr.Assets_Field_Dates[indextr])
                    "
                    class="mb-2"
                  >
                  </b-form-datepicker>
                </b-col>
              </b-col>
              <b-col cols="1">
                <confirmDel
                  :id="assetAttr.Assets_Field_Dates[indextr].id"
                  :attrName="
                    assetAttr.Assets_Field_Dates[indextr]
                      .asset_FieldDate_CusName
                  "
                  type="Date"
                  size="sm"
                  class="confirmDel"
                />
              </b-col>
            </b-row>

            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_Dropdowns"
              class="rowAttrAsset"
              style="align-items: center"
            >
              <b-col cols="1">fix</b-col>
              <b-col cols="2">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  format_list_numbered
                </span>
                {{
                  assetAttr.Assets_Field_Dropdowns[indextr]
                    .asset_FieldDropdown_Name
                }}
              </b-col>
              <b-col cols="8">
                <div
                  v-if="
                    assetAttr.Assets_Field_Dropdowns[indextr]
                      .Assets_Field_Dropdown_Options.length > 0
                  "
                >
                  <b-dropdown
                    :text="isSelectDropdown"
                    variant="outline-primary"
                  >
                    <b-dropdown-item
                      :key="i"
                      v-for="i in assetAttr.Assets_Field_Dropdowns[indextr]
                        .Assets_Field_Dropdown_Options"
                    >
                      {{ i.data_Optio }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>

                <div v-else>
                  <vs-button
                    radius
                    color="primary"
                    type="border"
                    icon="add"
                  ></vs-button>
                </div>
              </b-col>
              <confirmDel
                :id="assetAttr.Assets_Field_Dropdowns[indextr].id"
                :attrName="
                  assetAttr.Assets_Field_Dropdowns[indextr]
                    .asset_FieldDropdown_Name
                "
                type="Dropdown"
                size="sm"
                class="confirmDel"
              />
            </b-row>

            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_Pictures"
              class="rowAttrAsset"
            >
              <b-col cols="1" style="padding: 2em 0em">fix</b-col>
              <b-col cols="2" style="padding: 2em 0em">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  photo_camera
                </span>
                {{
                  assetAttr.Assets_Field_Pictures[indextr]
                    .asset_FieldPicture_Name
                }}
              </b-col>
              <b-col cols="8">
                <div class="con-example-images">
                  <vs-images>
                    <vs-image
                      v-for="item in picKeyObj.medium"
                      :key="item"
                      :src="picKeyObj.dir + item"
                    />
                  </vs-images>
                </div>

                <div class="centerx">
                  <div class="con-example-images">
                    <vs-images>
                      <vs-image
                        :key="i"
                        v-for="i in assetAttr.Assets_Field_Pictures
                          .asset_FieldPicture_Key"
                        :src="
                          assetAttr.Assets_Field_Pictures.asset_FieldPicture_Key
                            .dir + i.medium
                        "
                      />

                      <vs-button
                        radius
                        color="primary"
                        type="border"
                        icon="add"
                        style="margin: 3em"
                      ></vs-button>
                    </vs-images>
                  </div>
                </div>
              </b-col>
              <b-col cols="1" style="padding: 2em 0em"></b-col>
            </b-row>

            <b-row
              :key="indextr"
              v-for="(tr, indextr) in assetAttr.Assets_Field_Documents"
              class="rowAttrAsset"
            >
              <b-col cols="1">fix</b-col>
              <b-col cols="2">
                <span
                  class="material-icons-outlined"
                  style="line-height: 1em; font-size: 1em"
                >
                  upload_file
                </span>
                {{
                  assetAttr.Assets_Field_Documents[indextr]
                    .asset_FieldDocument_Name
                }}
              </b-col>
              <b-col cols="8">
                <div>
                  <template
                    v-if="
                      assetAttr.Assets_Field_Documents[indextr]
                        .asset_FieldDocument_Key.key.length == 0
                    "
                  >
                    <vs-chip>n/a</vs-chip>
                  </template>
                </div>

                <vs-chip
                  closable
                  v-for="item in assetAttr.Assets_Field_Documents[indextr]
                    .asset_FieldDocument_Key.key"
                  :key="item"
                >
                  {{ splitDocName(item) }}
                </vs-chip>
              </b-col>
              <b-col cols="1"></b-col>
            </b-row>
          </b-container>
        </b-card>
      </b-skeleton-wrapper>

      <BtnAddField :assetID="assetID" />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import BtnAddField from "@/TreeListMaster/button/BtnAddField";
import BtnQrcode from "@/TreeListMaster/button/BtnQr_code";
import confirmDel from "@/TreeListMaster/Tabs/dialogbox/confirmDel";
import ax from "axios";

export default {
  props: {
    options1: Array,
    assetdata: Object,
  },
  components: {
    BtnAddField,
    BtnQrcode,
    confirmDel,
  },
  created() {},
  data() {
    return {
      isSelectDropdown: "",
      attrAssetLength: "",
      dataDttitle: "test title",
      tablestate: "",
      loading: false,
      loadingTime: 0,
      maxLoadingTime: 3,
      assetID: 18,
      docName: "",
      srcImgPopup:
        "https://images.pexels.com/photos/1440406/pexels-photo-1440406.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1260",
      assetAttr: [".."],
      textTypeData: [],
      picKeyObj: {},
    };
  },
  beforeMount() {
    this.getUnits();
  },
  Mount() {},
  watch: {},
  computed: {},
  methods: {
    async getUnits() {
      await ax
        .get(`${this.$url2}asset/get-info-attr-asset?assetID=${18}`)
        .then((res) => {
          this.assetAttr = res.data.data[0];
          this.picKeyObj =
            res.data.data[0].Assets_Field_Pictures[0].asset_FieldPicture_Key;
        })
        .catch((res) => {});
    },
    async updateAttrAssetText(i) {
      await ax
        .put(`${this.$url2}asset/edit-textattr-asset`, {
          assetID: i.childrenAsset_id,
          id: i.id,
          assetFieldTextCusName: i.asset_FieldText_CusName,
          assetFieldTextData: document.getElementById("txt" + i.id).value,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
          this.getUnits();
          this.stopLoading();
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
        });
    },
    async updateAttrAssetNum(i) {
      await ax
        .put(`${this.$url2}asset/edit-numattr-asset`, {
          assetID: parseInt(i.childrenAsset_id),
          id: parseInt(i.id),
          assetFieldNumData: parseInt(
            document.getElementById("num" + i.id).value
          ),
        })
        .then((res) => {
          this.startLoading();
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
          this.stopLoading();
        })
        .catch((error) => {
          this.startLoading();
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
          this.stopLoading();
          this.$forceUpdate();
        });
    },
    async updateAttrAssetCUR(i) {
      let curValue = parseFloat(document.getElementById("cur" + i.id).value);
      if (curValue == null || curValue == "") {
        curValue = 0;
      }

      await ax
        .put(`${this.$url2}asset/edit-curattr-asset`, {
          assetID: parseInt(i.childrenAsset_id),
          id: parseInt(i.id),
          assetFieldCURData: curValue,
          assetFieldCURISOCode: "THB",
        })
        .then((res) => {
          this.startLoading();
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
          this.stopLoading();
        })
        .catch((error) => {
          this.startLoading();
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
          this.stopLoading();
        });
    },
    async updateAttrAssetDate(i) {
      await ax
        .put(`${this.$url2}asset/edit-dateattr-asset`, {
          assetID: parseInt(i.childrenAsset_id),
          id: parseInt(i.id),
          assetFieldDateData: i.asset_FieldDate_Data,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            title: "updated successfuly",
            text: res.data.message,
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "updated error",
            text: error.response.data.message,
            position: "top-center",
          });
        });
    },
    nextLoading() {
      this.startLoading();
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    errorUpload() {
      this.$vs.notify({
        color: "danger",
        title: "Upload error",
        text: "can not upload image please try again",
        position: "top-center",
      });
    },
    startLoading() {
      this.loading = true;
      this.loadingTime = 0;
    },
    stopLoading() {
      this.loading = false;
    },
    splitDocName(i) {
      let str = i.split("asset/attribute/doc/").pop().split("?")[0];
      return str;
    },
    getdropdownID(i) {
      console.log("i : ", i);
    },
    selectThisOptn(i) {
      this.isSelectDropdown = i.data_Optio;
    },
  },
};
</script>

<style scoped>
.card-body {
  padding: 0em 1em 1em 1em;
}
.confirmDel {
  display: none;
}
.rowAttrAsset {
  padding: 0.5em 0em;
  border-bottom: solid 0.5px #e7e7e7;
}
.rowAttrAsset:hover .confirmDel {
  display: block;
}
</style>

<style>
.CURsright {
  text-align: right !important;
}
.con-input-upload {
  margin: auto;
}

/* .mock-img {
  width: 150px;
}
.con-input-upload {
  width: 190px;
  height: 180px;
  border-radius: 100%;
}

.con-img-upload {
  margin-top: -30px;
}

.con-example-images {
  max-height: 500px;
}

.con-example-images .vs-image--img {
  max-height: 90px;
}
.v .vs-image--img {
  background-size: cover;
}

 */
.vs-image {
  width: calc(20% - 4px);
}
</style>
